import { Text } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC } from 'react'

import { spaceGrotesk } from '@/app/fonts'

const AnimatedTitle: FC<{ title: string; withDelay?: boolean }> = ({ title, withDelay }) => {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 3,
            }}
        >
            <Box
                sx={{
                    width: 'max-content',
                    textAlign: 'center',
                }}
            >
                <Text
                    variant={'body3'}
                    sx={{
                        fontFamily: `${spaceGrotesk.style.fontFamily}`,
                        color: '#048327',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        width: 0,
                        display: 'inline-block',
                        animation: `expandText .3s ease-out forwards ${withDelay ? '.3s' : '0s'}`,
                        fontWeight: 700,
                        fontSize: {
                            xs: '12px',
                            md: '16px',
                        },
                        lineHeight: {
                            xs: '14px',
                            md: '22.4px',
                        },

                        '@keyframes expandText': {
                            '0%': {
                                width: '0',
                            },
                            '100%': {
                                width: '100%',
                            },
                        },
                    }}
                >
                    {title}
                </Text>
            </Box>
        </Box>
    )
}

export default AnimatedTitle
